/**
 * @author Iulian Ceapa <dev@sitemd.net>
 * @copyright © 2019-2025 SiteMD.
 */

Fancybox.bind('[data-fancybox]', {
        Toolbar: {
            display: {
                // left: ["counter"],
                // middle: [],
                right: ["download", "zoomIn", "fullscreen", "thumbs", "close"],
            },
        },
});

$(document).ready(function () {
    if ($('.gallery').length > 0) {
        var grid = document.querySelector('.gallery');
        var msnry;

        imagesLoaded(grid, function () {
            msnry = new Masonry(grid, {
                itemSelector: 'a',
                gutter: '.gutter-sizer'
            });

            $('.gallery-loader').remove();
            $('.gallery').addClass('is-ready');
        });
    }
});